import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function StopoverStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.9482 1.06734C11.1084 1.08182 11.2598 1.14748 11.3799 1.25462L15.4428 4.87877L17.1074 4.82994L17.1368 4.83138C18.1434 4.88071 19.2377 5.34414 19.9181 5.99109L19.9252 5.99786L20.9279 7.00274C21.9425 8.05024 21.2517 9.76365 19.8322 9.85351L19.8202 9.85427L15.5154 9.98866L9.96099 14.0719C9.83187 14.1668 9.67575 14.2179 9.5155 14.2176L6.93563 14.2133C6.65173 14.2128 6.39243 14.0521 6.26573 13.7981C6.13902 13.544 6.16662 13.2402 6.33704 13.0131L8.8337 9.68655L5.42111 9.25661C5.18044 9.22629 4.96929 9.08144 4.85437 8.86781L2.73184 4.92231C2.60543 4.68732 2.61339 4.40286 2.75274 4.17531C2.89209 3.94775 3.14186 3.81138 3.40863 3.81717L5.6348 3.86555C5.8455 3.87013 6.04455 3.96315 6.18323 4.12184L7.05965 5.12468L9.79021 5.04458L8.207 1.97697C8.08147 1.73375 8.0984 1.44145 8.25119 1.21436C8.40397 0.987257 8.66834 0.861423 8.94094 0.886045L10.9482 1.06734ZM11.453 4.9958L13.2612 4.94276L10.5664 2.53897L10.1664 2.50284L11.453 4.9958ZM9.83827 8.30126L10.1889 7.88263C10.4499 7.57108 10.9115 7.52407 11.2299 7.77663C11.5484 8.02918 11.6077 8.48939 11.3637 8.81443L8.43563 12.7158L9.2713 12.7172L14.8148 8.64202C14.9371 8.55209 15.0839 8.50141 15.2356 8.49667L19.745 8.35588C19.8941 8.34084 19.9625 8.16579 19.8529 8.04902L18.8779 7.07193C18.4744 6.69217 17.7449 6.37091 17.0906 6.33108L6.74983 6.63441C6.52581 6.64098 6.31059 6.54702 6.16311 6.37827L5.27147 5.35801L4.66239 5.34477L5.99219 7.8167L9.83827 8.30126Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 18.75C11.3096 18.75 10.75 19.3096 10.75 20C10.75 20.6903 11.3096 21.25 12 21.25C12.6904 21.25 13.25 20.6903 13.25 20C13.25 19.3096 12.6904 18.75 12 18.75ZM9.25 20C9.25 18.4812 10.4812 17.25 12 17.25C13.5188 17.25 14.75 18.4812 14.75 20C14.75 21.5188 13.5188 22.75 12 22.75C10.4812 22.75 9.25 21.5188 9.25 20Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0.75 20C0.75 19.5858 1.08579 19.25 1.5 19.25H3.3C3.71421 19.25 4.05 19.5858 4.05 20C4.05 20.4142 3.71421 20.75 3.3 20.75H1.5C1.08579 20.75 0.75 20.4142 0.75 20ZM4.95 20C4.95 19.5858 5.28579 19.25 5.7 19.25H7.5C7.91421 19.25 8.25 19.5858 8.25 20C8.25 20.4142 7.91421 20.75 7.5 20.75H5.7C5.28579 20.75 4.95 20.4142 4.95 20Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.75 20C15.75 19.5858 16.0858 19.25 16.5 19.25H18.3C18.7142 19.25 19.05 19.5858 19.05 20C19.05 20.4142 18.7142 20.75 18.3 20.75H16.5C16.0858 20.75 15.75 20.4142 15.75 20ZM19.95 20C19.95 19.5858 20.2858 19.25 20.7 19.25H22.5C22.9142 19.25 23.25 19.5858 23.25 20C23.25 20.4142 22.9142 20.75 22.5 20.75H20.7C20.2858 20.75 19.95 20.4142 19.95 20Z"
				fill="currentColor"
			/>
		</svg>
	);
}

StopoverStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default StopoverStrokeIcon;
